import { IInquirySeed } from '@/entities/Inquiry'
import InquiryValidator from '@/utils/validators/domain/Inquiry'
import {
  emailEmptyError,
  emailFormatError,
  emailLengthError,
  nameEmptyError,
  inquiryCategoryEmptyError,
  inquiryContentEmptyError,
  inquiryOrderNumberEmptyError,
  inquiryOrderNumberFormatError,
  inquiryOrderNumberLengthError
} from '@/const/errorMessage'

export type Fields = IInquirySeed
export type FieldErrors = { [key in keyof Fields]: string[] }

export default class SignupAccountValidator {
  static validate(fields: Partial<Fields>): FieldErrors {
    const errors: FieldErrors = {
      category: [],
      name: [],
      email: [],
      orderNumber: [],
      content: []
    }

    const validator = new InquiryValidator(fields)

    if (fields.category !== undefined) {
      if (!fields.category) {
        errors.category.push(inquiryCategoryEmptyError)
      }
    }

    if (fields.email !== undefined) {
      if (!fields.email) {
        errors.email.push(emailEmptyError)
      } else {
        if (!validator.isEmailFormatValid()) {
          errors.email.push(emailFormatError)
        }

        if (!validator.isEmailLengthValid()) {
          errors.email.push(emailLengthError)
        }
      }
    }

    if (fields.name !== undefined) {
      if (!fields.name) {
        errors.name.push(nameEmptyError)
      }
    }

    if (fields.orderNumber !== undefined) {
      if (!fields.orderNumber) {
        errors.orderNumber.push(inquiryOrderNumberEmptyError)
      } else {
        if (!validator.isOrderNumberFormatValid()) {
          errors.orderNumber.push(inquiryOrderNumberFormatError)
        }

        if (!validator.isOrderNumberLengthValid()) {
          errors.orderNumber.push(inquiryOrderNumberLengthError)
        }
      }
    }

    if (fields.content !== undefined) {
      if (!fields.content) {
        errors.content.push(inquiryContentEmptyError)
      }
    }

    return errors
  }
}
